<template>
    <div class="hashrate-matchConf-page">
        <div style="font-weight: bold;font-size: 18px;">
            <span>挖矿活动奖励发放</span>
            <el-button style="margin-left: 10px" type="danger" @click="openConfig">收益数据配置</el-button>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top: 20px">
            <el-tab-pane label="奖励列表" name="REWARDLIST"></el-tab-pane>
            <el-tab-pane label="生成奖励" name="CREATREWARD"></el-tab-pane>
            <el-tab-pane label="发放奖励" name="GRANTREWARD"></el-tab-pane>
            <el-tab-pane label="删除奖励" name="DELETEREWARD"></el-tab-pane>
        </el-tabs>
        <el-form :inline="true" style="margin-top: 20px;" class="header-box">
            <el-form-item label="算力机构"
                          v-if="activeName=='REWARDLIST' || activeName=='CREATREWARD' || activeName=='GRANTREWARD' || activeName=='DELETEREWARD'">
                <el-select v-model="serchInfo.company" placeholder="请选择">
                    <el-option v-for="item in companyList" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="收益类型"
                          v-if="activeName=='REWARDLIST' || activeName=='CREATREWARD' || activeName=='GRANTREWARD' || activeName=='DELETEREWARD'">
                <el-select v-model="serchInfo.gainType" placeholder="请选择">
                    <el-option label="挖矿收益" value="1"></el-option>
                    <el-option label="IPFS测试网奖励" value="2"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="云算力类型"
                          v-if="activeName=='REWARDLIST' || activeName=='CREATREWARD' || activeName=='GRANTREWARD' || activeName=='DELETEREWARD'">
                <el-select v-model="serchInfo.hashrateType" placeholder="请选择">
                    <el-option label="IPFS" value="IPFS"></el-option>
                    <el-option label="Chia" value="Chia"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="状态" v-if="activeName=='REWARDLIST'">
                <el-select v-model="serchInfo.status" placeholder="请选择">
                    <el-option label="发放" value="2"></el-option>
                    <el-option label="转账中" value="3"></el-option>
                    <el-option label="转账完成" value="4"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="收益日期"
                          v-if="activeName=='REWARDLIST' || activeName=='CREATREWARD' || activeName=='GRANTREWARD' || activeName=='DELETEREWARD'">
                <el-date-picker v-model="serchInfo.rewardDate" value-format="timestamp" type="date" placeholder="请选择">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="每TB收益" v-if="activeName=='CREATREWARD'">
                <el-input v-model="serchInfo.miningForTB" placeholder="每TB收益"></el-input>
            </el-form-item>

            <el-form-item label="用户ID" v-if="activeName=='REWARDLIST'">
                <el-input v-model="serchInfo.userId" placeholder="用户ID"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="search()"
                           v-if="activeName=='REWARDLIST' || activeName=='GRANTREWARD' || activeName=='DELETEREWARD'">搜索
                </el-button>
                <el-button type="success" @click="createReward()" v-if="activeName=='CREATREWARD'">生成奖励</el-button>
                <el-button type="danger" @click="grantReward()" v-if="activeName=='GRANTREWARD'">发放奖励</el-button>
                <el-button type="danger" @click="deleteReward()" v-if="activeName=='DELETEREWARD'">删除奖励</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="listInfo" :row-key="() => Math.random()">
            <el-table-column label="记录ID" prop="id"></el-table-column>
            <el-table-column label="用户账户" prop="userId"></el-table-column>
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="币种" prop="coinType"></el-table-column>
            <el-table-column label="云算力类型" prop="hashrateType"></el-table-column>
            <el-table-column label="云算力名称" prop="hashrateName"></el-table-column>
            <el-table-column label="算力提供商" prop="hashrateCompanyName"></el-table-column>
            <el-table-column label="认购份数" prop="hashrateAmount"></el-table-column>
            <el-table-column label="当天产出" prop="cycleTotalOutput"></el-table-column>
            <el-table-column label="收益奖励" prop="coinAmount"></el-table-column>
            <el-table-column label="收益类型" prop="gainType">
                <template slot-scope="scope">
                    <span v-if="scope.row.gainType == 2">ipfs测试网奖励</span>
                    <span v-else-if="scope.row.gainType == 1">挖矿</span>
                </template>
            </el-table-column>
            <el-table-column label="收益时间" prop="recruitTime">
                <template slot-scope="scope">{{ scope.row.gainTime | moment }}</template>
            </el-table-column>
            <el-table-column label="状态" prop="status">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">创建</span>
                    <span v-if="scope.row.status == 2">发放</span>
                    <span v-else-if="scope.row.status == 3">转账中</span>
                    <span v-else-if="scope.row.status == 4">转账完成</span>
                </template>
            </el-table-column>
        </el-table>

        <div class="footer-box" style="margin-top: 20px">
            <el-pagination
                    @size-change="sizeChange"
                    @current-change="pageChange"
                    :current-page="serchInfo.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="serchInfo.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import "./store";
    import api from "./api";
    import {mapActions, mapState} from "vuex";

    export default {
        name: "match",
        data() {
            return {
                listInfo: [], //数据列表
                total: 0, //总条数
                serchInfo: {
                    company: "1",
                    gainType: "1",
                    hashrateType: "IPFS",
                    rewardDate: "",
                    userId: "",
                    miningForTB: "",
                    page: 1,
                    size: 10,
                    status: "2"
                },
                activeName: "REWARDLIST",
                companyList: []
            };
        },
        created() {
            this.companyConfig();
            // this.getRewardList(this.serchInfo);
        },
        methods: {
            search() {
                this.serchInfo.page = 1;
                this.getRewardList(this.serchInfo)
            },
            getRewardList(query) {
                if (this.activeName == 'GRANTREWARD' || this.activeName == 'DELETEREWARD') {
                    if (this.serchInfo.rewardDate == "" || this.serchInfo.rewardDate == null) {
                        this.$message.success("请选择收益日期");
                        return;
                    }
                }
                api.rewardList(query).then(({data}) => {
                    console.log(data)
                    this.total = data.totalCount;
                    this.listInfo = data.list;
                })
            },
            companyConfig() {
                api.companyConfig().then(({data}) => {
                    Object.keys(data).map(key => {
                        this.companyList.push({label: data[key], value: key})
                    })
                })
            },
            sizeChange(val) {
                this.serchInfo.size = val;
                this.getRewardList(this.serchInfo);
            },
            pageChange(val) {
                this.serchInfo.page = val;
                this.getRewardList(this.serchInfo);
            },
            createReward() {
                if (this.serchInfo.company == "") {
                    this.$message.success("请选择算力机构");
                    return;
                }
                if (this.serchInfo.gainType == "") {
                    this.$message.success("请选择收益类型");
                    return;
                }
                if (this.serchInfo.hashrateType == "") {
                    this.$message.success("请选择运算力类型");
                    return;
                }
                if (this.serchInfo.rewardDate == "" || this.serchInfo.rewardDate == null) {
                    this.$message.success("请选择收益日期");
                    return;
                }
                if (this.serchInfo.miningForTB == "") {
                    this.$message.success("请填写每TB收益");
                    return;
                }
                api.createReward(this.serchInfo).then(res => {
                    if (!res.code) {
                        this.$message.success("生成奖励成功");
                        this.getRewardList(this.serchInfo);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            deleteReward() {
                if (this.serchInfo.company == "") {
                    this.$message.success("请选择算力机构");
                    return;
                }
                if (this.serchInfo.hashrateType == "") {
                    this.$message.success("请选择运算力类型");
                    return;
                }
                if (this.serchInfo.rewardDate == "" || this.serchInfo.rewardDate == null) {
                    this.$message.success("请选择收益日期");
                    return;
                }
                api.deleteReward(this.serchInfo).then(res => {
                    if (!res.code) {
                        this.$message.success("删除奖励成功");
                        this.getRewardList(this.serchInfo);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //发放
            grantReward() {
                if (this.serchInfo.company == "") {
                    this.$message.success("请选择算力机构");
                    return;
                }
                if (this.serchInfo.hashrateType == "") {
                    this.$message.success("请选择运算力类型");
                    return;
                }
                if (this.serchInfo.rewardDate == "" || this.serchInfo.rewardDate == null) {
                    this.$message.success("请选择收益日期");
                    return;
                }
                api.grantReward(this.serchInfo).then(res => {
                    if (!res.code) {
                        this.$message.success("发放奖励成功");
                        this.getRewardList(this.serchInfo);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            handleClick() {
                this.listInfo = []; //数据列表
                this.total = 0; //总条数
                this.serchInfo = {
                    company: "1",
                    gainType: "1",
                    hashrateType: "IPFS",
                    rewardDate: "",
                    userId: "",
                    miningForTB: "",
                    page: 1,
                    size: 10,
                    status: (this.activeName == 'GRANTREWARD' || this.activeName == 'DELETEREWARD') ? "1" : (this.activeName == 'REWARDLIST' ? "2" : "")
                }
            },
            openConfig() {
                this.$router.push({
                    path: '/home/hashrate/hashRateConfig'
                });
            }
        }
    };
</script>

<style lang="less">
    .hashrate-matchConf-page {
        .header-box {
            width: 90%;
            // border: 1px solid #cccccc;
            padding: 16px;
            .el-form-item {
                padding-right: 30px;
            }
        }
    }
</style>
